import mitt from "mitt"
// 使用发布订阅解决banner通信问题
export const { emit, on, off } = mitt()

class Banner {
  protected addPrefix = "add:"
  protected removePrefix = "remove:"
  protected getAddKey(id) {
    return `${this.addPrefix}${id}`
  }
  protected getRemoveKey(id) {
    return `${this.removePrefix}${id}`
  }
  triggerAdd(id, content) {
    emit(this.getAddKey(id), content)
  }
  triggerRemove(id) {
    emit(this.getRemoveKey(id))
  }
  subscribeAdd(id, cb) {
    on(this.getAddKey(id), cb)
  }
  subscribeRemove(id, cb) {
    on(this.getRemoveKey(id), cb)
  }
  unsubscribeAdd(id, cb?) {
    off(this.getAddKey(id), cb)
  }
  unsubscribeRemove(id, cb?) {
    off(this.getRemoveKey(id), cb)
  }
}

export const bannerBridge = new Banner()
